var hashtag_default = {
  "fontElementMap": "gnxNb",
  "hashtag": "scUya"
};
export {
  hashtag_default as default
};
//# sourceMappingURL=hashtag-scss.js.map
